(function() {
  function isVariantAvailable(variant) {
    return variant && variant.available === true;
  }

  function findFirstAvailableVariant(variants) {
    if (!Array.isArray(variants) || !variants.length) return null;
    return variants.find(function(v) { return isVariantAvailable(v); }) || null;
  }

  // Title overflow check
  function checkTitleOverflow() {
    document.querySelectorAll('.product-card__title-wrapper').forEach(function(wrapper) {
      var textEl = wrapper.querySelector('.product-card__title-text');
      if (textEl && wrapper.offsetWidth < textEl.offsetWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    });
  }
  
  // Price overflow check - marquee when prices don't fit
  function checkPriceOverflow() {
    document.querySelectorAll('.product-card__price-wrapper').forEach(function(wrapper) {
      var card = wrapper.closest('.product-card');
      if (card && !card.classList.contains('product-card--price-marquee-enabled')) {
        wrapper.classList.remove('is-overflowing');
        return;
      }
      var priceRow = wrapper.querySelector('.product-card__price-row:not(.product-card__price-row--duplicate)');
      if (priceRow && wrapper.offsetWidth < priceRow.scrollWidth) {
        wrapper.classList.add('is-overflowing');
      } else {
        wrapper.classList.remove('is-overflowing');
      }
    });
  }
  
  // Media carousel functionality (images + videos)
  var cardData = new Map();
  var IMAGE_DURATION = 3000; // 3 seconds per image
  var HEALIX_COLOR_OPTION_NAMES = ['color', 'colour'];
  var healixColorGroupsCache = new Map();
  var healixProductCache = new Map();
  
  function startCarousel(container) {
    var mediaItems = container.querySelectorAll('.product-card__media');
    var progressContainer = container.querySelector('.product-card__image-progress');
    var pill = progressContainer ? progressContainer.querySelector('.product-card__progress-pill') : null;
    var mediaCount = parseInt(container.getAttribute('data-media-count'), 10);
    
    if (mediaCount <= 1) return;
    if (cardData.has(container)) return; // Already running
    
    var currentIndex = 0;
    var timeoutId = null;
    var videoEndedHandler = null;
    
    function setPillDuration(durationMs) {
      if (pill) {
        pill.style.setProperty('--pill-duration', (durationMs / 1000) + 's');
      }
    }
    
    function restartPillAnimation() {
      if (pill) {
        pill.classList.remove('is-filling');
        void pill.offsetWidth; // Force reflow
        pill.classList.add('is-filling');
      }
    }
    
    function nextSlide() {
      var nextIndex = (currentIndex + 1) % mediaCount;
      showSlide(nextIndex);
    }
    
    function scheduleNextSlide() {
      var currentMedia = mediaItems[currentIndex];
      var isVideo = currentMedia && currentMedia.tagName.toLowerCase() === 'video';
      
      // Clean up previous handler
      if (videoEndedHandler) {
        mediaItems.forEach(function(m) {
          if (m.tagName.toLowerCase() === 'video') {
            m.removeEventListener('ended', videoEndedHandler);
          }
        });
      }
      
      if (isVideo) {
        // Create new handler for this video
        videoEndedHandler = function() {
          nextSlide();
        };
        currentMedia.addEventListener('ended', videoEndedHandler, { once: true });
        
        // Set pill duration to video duration
        if (currentMedia.duration && !isNaN(currentMedia.duration)) {
          setPillDuration(currentMedia.duration * 1000);
          restartPillAnimation();
        } else {
          // Wait for metadata
          currentMedia.addEventListener('loadedmetadata', function() {
            if (currentMedia.duration && !isNaN(currentMedia.duration)) {
              setPillDuration(currentMedia.duration * 1000);
              restartPillAnimation();
            }
          }, { once: true });
          // Start with default for now
          setPillDuration(IMAGE_DURATION);
          restartPillAnimation();
        }
      } else {
        // For images, use fixed duration
        setPillDuration(IMAGE_DURATION);
        restartPillAnimation();
        timeoutId = setTimeout(nextSlide, IMAGE_DURATION);
      }
    }
    
    function showSlide(newIndex) {
      var prevIndex = currentIndex;
      currentIndex = newIndex;
      
      // Clear any pending timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      
      // Smooth crossfade between media
      mediaItems.forEach(function(media, i) {
        var isVideo = media.tagName.toLowerCase() === 'video';
        
        if (i === prevIndex && i !== newIndex) {
          media.classList.add('is-leaving');
          media.classList.remove('is-active');
          if (isVideo) {
            media.pause();
            media.currentTime = 0;
          }
        } else if (i === newIndex) {
          media.classList.remove('is-leaving');
          media.classList.add('is-active');
          if (isVideo) {
            media.currentTime = 0;
            media.play().catch(function() {});
          }
        } else {
          media.classList.remove('is-active', 'is-leaving');
          if (isVideo) {
            media.pause();
            media.currentTime = 0;
          }
        }
      });
      
      // Remove leaving class after transition
      setTimeout(function() {
        mediaItems.forEach(function(media) {
          media.classList.remove('is-leaving');
        });
      }, 600);
      
      // Schedule next slide
      scheduleNextSlide();
    }
    
    // Initial setup - show first slide
    var firstMedia = mediaItems[0];
    var isFirstVideo = firstMedia && firstMedia.tagName.toLowerCase() === 'video';
    
    // Make sure first is active
    firstMedia.classList.add('is-active');
    
    // Start first video if needed
    if (isFirstVideo) {
      firstMedia.currentTime = 0;
      firstMedia.play().catch(function() {});
    }
    
    // Schedule next slide (this also starts the pill animation)
    scheduleNextSlide();
    
    cardData.set(container, {
      currentIndex: currentIndex,
      cleanup: function() {
        if (timeoutId) clearTimeout(timeoutId);
        if (videoEndedHandler) {
          mediaItems.forEach(function(media) {
            if (media.tagName.toLowerCase() === 'video') {
              media.removeEventListener('ended', videoEndedHandler);
            }
          });
        }
      }
    });
  }
  
  function stopCarousel(container) {
    var data = cardData.get(container);
    if (data) {
      if (data.cleanup) data.cleanup();
      cardData.delete(container);
    }
    
    // Reset to first media smoothly
    var mediaItems = container.querySelectorAll('.product-card__media');
    var pill = container.querySelector('.product-card__progress-pill');
    
    mediaItems.forEach(function(media, i) {
      var isVideo = media.tagName.toLowerCase() === 'video';
      media.classList.remove('is-leaving');
      media.classList.toggle('is-active', i === 0);
      
      if (isVideo) {
        media.pause();
        media.currentTime = 0;
      }
    });
    
    if (pill) {
      pill.classList.remove('is-filling');
      pill.style.removeProperty('--pill-duration');
    }
  }
  
  function initCarousels() {
    var containers = document.querySelectorAll('.product-card__image-container[data-media-count]');
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startCarousel(entry.target);
        } else {
          stopCarousel(entry.target);
        }
      });
    }, {
      threshold: 0.5
    });
    
    containers.forEach(function(container) {
      var mediaCount = parseInt(container.getAttribute('data-media-count'), 10);
      if (mediaCount > 1) {
        observer.observe(container);
      }
    });
    
    // Handle single video cards (autoplay when in view, these keep loop attribute)
    var singleVideoCards = document.querySelectorAll('.product-card__image-container:not([data-media-count]) .product-card__video');
    if (singleVideoCards.length > 0) {
      var videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function() {});
          } else {
            video.pause();
          }
        });
      }, {
        threshold: 0.5
      });
      
      singleVideoCards.forEach(function(video) {
        videoObserver.observe(video);
      });
    }
  }
  
  // Badge rotation functionality
  var badgeData = new Map();
  
  function startBadgeRotation(container) {
    var badges = container.querySelectorAll('.product-card__badge');
    var rotationSpeed = parseInt(container.getAttribute('data-rotation-speed'), 10) || 3;
    var rotationMs = rotationSpeed * 1000;
    
    if (badges.length <= 1) return;
    if (badgeData.has(container)) return; // Already running
    
    var currentIndex = 0;
    
    // Set initial active state
    badges[0].classList.add('is-active');
    
    function showBadge(newIndex) {
      var prevIndex = currentIndex;
      currentIndex = newIndex;
      
      badges.forEach(function(badge, i) {
        if (i === prevIndex && i !== newIndex) {
          badge.classList.add('is-leaving');
          badge.classList.remove('is-active');
        } else if (i === newIndex) {
          badge.classList.remove('is-leaving');
          badge.classList.add('is-active');
        } else {
          badge.classList.remove('is-active', 'is-leaving');
        }
      });
      
      // Remove leaving class after transition
      setTimeout(function() {
        badges.forEach(function(badge) {
          badge.classList.remove('is-leaving');
        });
      }, 300);
    }
    
    function nextBadge() {
      var nextIndex = (currentIndex + 1) % badges.length;
      showBadge(nextIndex);
    }
    
    var intervalId = setInterval(nextBadge, rotationMs);
    badgeData.set(container, { intervalId: intervalId });
  }
  
  function stopBadgeRotation(container) {
    var data = badgeData.get(container);
    if (data) {
      clearInterval(data.intervalId);
      badgeData.delete(container);
    }
    
    // Reset to first badge
    var badges = container.querySelectorAll('.product-card__badge');
    badges.forEach(function(badge, i) {
      badge.classList.remove('is-leaving');
      badge.classList.toggle('is-active', i === 0);
    });
  }
  
  function initBadgeRotation() {
    var rotatingContainers = document.querySelectorAll('.product-card__badges--rotating');
    
    if (rotatingContainers.length === 0) return;
    
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startBadgeRotation(entry.target);
        } else {
          stopBadgeRotation(entry.target);
        }
      });
    }, {
      threshold: 0.3
    });
    
    rotatingContainers.forEach(function(container) {
      observer.observe(container);
    });
  }
  
  function formatMoney(cents, format) {
    if (window.formatMoney) {
      return window.formatMoney(cents, format);
    }
    if (window.formatMoneyFallback) {
      return window.formatMoneyFallback(cents);
    }
    return (Number(cents || 0) / 100).toFixed(2);
  }

  function initSelectComponentsSafe() {
    if (!window.SelectComponent) return;
    document.querySelectorAll('[data-select]').forEach(function(el) {
      if (!el._selectComponent) {
        el._selectComponent = new window.SelectComponent(el);
      }
    });
  }

  function getSizedImageUrl(src, card) {
    if (!src) return src;
    if (!card) return src;
    var isCover = card.classList.contains('product-card--fit-cover');
    if (isCover) {
      return src.replace(/(\.[^.]+)$/, '_600x800_crop_center$1');
    }
    return src.replace(/(\.[^.]+)$/, '_600x$1');
  }

  // Healix-specific: rebuild full card media slider on color change.
  function healixNormalizeAssetUrl(url) {
    if (!url) return '';
    return String(url).split('?')[0].replace(/^https?:/, '');
  }

  function healixBuildProductMediaList(productData, preferredImageSrc) {
    var output = [];
    var sourceMedia = Array.isArray(productData && productData.media) ? productData.media.slice() : [];

    if (!sourceMedia.length && Array.isArray(productData && productData.images)) {
      sourceMedia = (productData.images || []).map(function(imageSrc, index) {
        return {
          media_type: 'image',
          src: imageSrc,
          alt: productData && productData.title ? productData.title : '',
          position: index + 1
        };
      });
    }

    sourceMedia.forEach(function(media) {
      if (!media) return;
      var type = String(media.media_type || 'image').toLowerCase();
      var normalized = {
        media_type: type,
        alt: media.alt || ''
      };

      if (type === 'video') {
        normalized.preview_src = media.preview_image && media.preview_image.src ? media.preview_image.src : '';
        normalized.sources = Array.isArray(media.sources) ? media.sources : [];
      } else if (type === 'external_video') {
        normalized.src = media.preview_image && media.preview_image.src
          ? media.preview_image.src
          : (media.src || '');
      } else {
        normalized.media_type = 'image';
        normalized.src = media.src || (media.preview_image && media.preview_image.src) || '';
      }

      if (!normalized.src && !normalized.preview_src) return;
      output.push(normalized);
    });

    var preferred = healixNormalizeAssetUrl(preferredImageSrc);
    if (preferred) {
      var preferredIndex = output.findIndex(function(media) {
        if (media.media_type === 'video') {
          return healixNormalizeAssetUrl(media.preview_src) === preferred;
        }
        return healixNormalizeAssetUrl(media.src) === preferred;
      });
      if (preferredIndex > 0) {
        var preferredMedia = output.splice(preferredIndex, 1)[0];
        output.unshift(preferredMedia);
      }
    }

    return output;
  }

  function healixCreateCardMediaNode(media, index, productTitle, card) {
    var type = String(media && media.media_type ? media.media_type : 'image').toLowerCase();
    var node = null;
    var isActive = index === 0;
    var title = productTitle || '';

    if (type === 'video') {
      node = document.createElement('video');
      node.className = 'product-card__media product-card__video' + (isActive ? ' is-active' : '');
      node.dataset.index = String(index);
      node.dataset.type = 'video';
      node.muted = true;
      node.playsInline = true;
      node.preload = 'metadata';
      if (media.preview_src) {
        node.poster = getSizedImageUrl(media.preview_src, card);
      }

      (media.sources || []).forEach(function(sourceObj) {
        var sourceUrl = sourceObj && (sourceObj.url || sourceObj.src);
        if (!sourceUrl) return;
        var sourceNode = document.createElement('source');
        sourceNode.src = sourceUrl;
        var sourceType = sourceObj.mime_type || sourceObj.mimeType || '';
        if (sourceType) {
          sourceNode.type = sourceType;
        }
        node.appendChild(sourceNode);
      });
      return node;
    }

    node = document.createElement('img');
    node.className = 'product-card__media product-card__image' + (isActive ? ' is-active' : '');
    node.loading = 'lazy';
    node.dataset.index = String(index);
    node.dataset.type = type === 'external_video' ? 'external_video' : 'image';
    node.alt = media.alt || title;
    node.src = getSizedImageUrl(media.src, card);
    return node;
  }

  function healixUpdateCardMediaCarousel(card, productData, selectedVariant) {
    var container = card ? card.querySelector('.product-card__image-container') : null;
    var slider = container ? container.querySelector('.product-card__image-slider') : null;
    if (!container || !slider) return;

    stopCarousel(container);

    var preferredImageSrc =
      (selectedVariant && selectedVariant.featured_image && selectedVariant.featured_image.src)
      || healixGetProductFeaturedImage(productData);
    var mediaList = healixBuildProductMediaList(productData, preferredImageSrc);
    if (!mediaList.length) return;

    slider.innerHTML = '';
    mediaList.forEach(function(media, index) {
      slider.appendChild(healixCreateCardMediaNode(media, index, productData && productData.title, card));
    });

    var progressContainer = container.querySelector('.product-card__image-progress');
    if (mediaList.length > 1) {
      container.setAttribute('data-media-count', String(mediaList.length));

      if (!progressContainer) {
        progressContainer = document.createElement('div');
        progressContainer.className = 'product-card__image-progress';
        container.appendChild(progressContainer);
      }
      progressContainer.setAttribute('data-total', String(mediaList.length));
      if (!progressContainer.querySelector('.product-card__progress-pill')) {
        var progressPill = document.createElement('span');
        progressPill.className = 'product-card__progress-pill is-filling';
        progressContainer.appendChild(progressPill);
      }

      startCarousel(container);
      return;
    }

    container.removeAttribute('data-media-count');
    if (progressContainer) {
      progressContainer.remove();
    }

    var firstMedia = slider.querySelector('.product-card__media');
    if (firstMedia && firstMedia.tagName && firstMedia.tagName.toLowerCase() === 'video') {
      firstMedia.currentTime = 0;
      firstMedia.play().catch(function() {});
    }
  }

  function updatePriceRow(row, price, comparePrice, moneyFormat) {
    var priceEl = row.querySelector('.product-card__price');
    if (priceEl) {
      priceEl.textContent = formatMoney(price, moneyFormat);
    }

    var compareEl = row.querySelector('.product-card__compare-price');
    if (comparePrice && comparePrice > price) {
      if (!compareEl && priceEl) {
        compareEl = priceEl.cloneNode(true);
        compareEl.classList.remove('product-card__price');
        compareEl.classList.add('product-card__compare-price');
        priceEl.insertAdjacentElement('afterend', compareEl);
      }
      if (compareEl) {
        compareEl.textContent = formatMoney(comparePrice, moneyFormat);
      }
    } else if (compareEl) {
      compareEl.remove();
    }
  }

  function updatePriceDisplay(card, price, comparePrice) {
    var priceWrapper = card.querySelector('.product-card__price-wrapper');
    if (!priceWrapper) return;

    var moneyFormat = card.getAttribute('data-money-format') || window.themeMoneyFormat;
    var rows = priceWrapper.querySelectorAll('.product-card__price-row');
    rows.forEach(function(row) {
      updatePriceRow(row, price, comparePrice, moneyFormat);
    });

      checkPriceOverflow();
  }

  function updateProductImage(card, variant, fallbackImageSrc) {
    var imageEl = card.querySelector('.product-card__image.is-active') || card.querySelector('.product-card__image');
    if (!imageEl) return;

    if (variant && variant.featured_image && variant.featured_image.src) {
      imageEl.src = getSizedImageUrl(variant.featured_image.src, card);
      return;
    }

    if (fallbackImageSrc) {
      imageEl.src = fallbackImageSrc;
    }
  }

  function updateProductLinks(card, variantId) {
    var productLink = card.querySelector('.product-card__image-container');
    if (productLink && productLink.getAttribute('href')) {
      var baseLink = productLink.getAttribute('href').split('?')[0];
      productLink.setAttribute('href', baseLink + '?variant=' + variantId);
    }

    var addBtn = card.querySelector('.product-card__add-btn');
    if (addBtn && addBtn.tagName.toLowerCase() === 'a' && addBtn.getAttribute('href')) {
      var baseBtnLink = addBtn.getAttribute('href').split('?')[0];
      addBtn.setAttribute('href', baseBtnLink + '?variant=' + variantId);
    }
  }

  // Healix-specific: utility helpers for API-backed color dropdown.
  function healixNormalizeToken(value) {
    if (value === null || value === undefined) return '';
    return String(value).toLowerCase().trim().replace(/[^a-z0-9]+/g, '');
  }

  function healixEscapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function healixSetCardColorTag(card, colorName, colorCode) {
    if (!card) return;
    var tagEl = card.querySelector('[data-healix-color-tag]');
    if (!tagEl) return;

    var labelEl = tagEl.querySelector('[data-healix-color-label]');
    var dotEl = tagEl.querySelector('[data-healix-color-dot]');

    var label = String(colorName || '').replace(/_/g, ' ').trim();
    if (!label) {
      if (labelEl && labelEl.textContent) {
        label = String(labelEl.textContent || '').trim();
      }
    }

    if (!label) {
      tagEl.classList.add('is-hidden');
      return;
    }

    if (labelEl) {
      labelEl.textContent = label;
    }
    if (dotEl) {
      dotEl.style.backgroundColor = String(colorCode || '#cccccc').trim() || '#cccccc';
    }
    tagEl.classList.remove('is-hidden');
  }

  function healixHydrateCardColorTag(card, handle) {
    if (!card) return;
    var normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return;

    healixLoadColorGroups(normalizedHandle).then(function(groups) {
      var items = groups && Array.isArray(groups.all) ? groups.all : [];
      var activeItem = items.find(function(item) {
        return String(item && item.handle || '').trim() === normalizedHandle;
      });
      if (!activeItem) return;
      healixSetCardColorTag(card, activeItem.colorName, activeItem.colorCode);
    });
  }

  function healixNormalizeOptionNames(rawOptions) {
    if (!Array.isArray(rawOptions)) return [];
    return rawOptions.map(function(option, index) {
      if (typeof option === 'string') return option;
      if (option && option.name) return String(option.name);
      return 'Option ' + (index + 1);
    });
  }

  function healixFindColorOptionIndex(optionNames) {
    if (!Array.isArray(optionNames)) return -1;
    for (var i = 0; i < optionNames.length; i += 1) {
      if (HEALIX_COLOR_OPTION_NAMES.indexOf(healixNormalizeToken(optionNames[i])) !== -1) {
        return i;
      }
    }
    return -1;
  }

  function healixVariantOptionValues(variant) {
    return [
      variant && variant.option1 ? String(variant.option1) : '',
      variant && variant.option2 ? String(variant.option2) : '',
      variant && variant.option3 ? String(variant.option3) : ''
    ];
  }

  function healixBuildPreferredSelections(variant, optionNames, colorOptionIndex) {
    var preferred = {};
    if (!variant) return preferred;
    var values = healixVariantOptionValues(variant);
    values.forEach(function(optionValue, index) {
      if (index === colorOptionIndex) return;
      var normalizedValue = String(optionValue || '').trim();
      if (!normalizedValue || normalizedValue.toLowerCase() === 'default title') return;
      var token = healixNormalizeToken(optionNames[index] || ('option' + (index + 1)));
      if (!token) return;
      preferred[token] = normalizedValue;
    });
    return preferred;
  }

  function healixFindVariantBySelections(variants, optionNames, colorOptionIndex, preferredSelections) {
    if (!Array.isArray(variants) || !variants.length) return null;
    var preferredKeys = Object.keys(preferredSelections || {});
    if (!preferredKeys.length) return null;

    return variants.find(function(variant) {
      var values = healixVariantOptionValues(variant);
      for (var index = 0; index < values.length; index += 1) {
        if (index === colorOptionIndex) continue;
        var token = healixNormalizeToken(optionNames[index] || ('option' + (index + 1)));
        if (!token || !preferredSelections[token]) continue;
        if (String(values[index] || '') !== String(preferredSelections[token] || '')) {
          return false;
        }
      }
      return true;
    }) || null;
  }

  function healixBuildVariantLabel(variant, optionNames, colorOptionIndex) {
    var values = healixVariantOptionValues(variant);
    var parts = [];
    values.forEach(function(optionValue, index) {
      if (index === colorOptionIndex) return;
      var normalizedValue = String(optionValue || '').trim();
      if (!normalizedValue || normalizedValue.toLowerCase() === 'default title') return;
      parts.push(normalizedValue);
    });
    if (parts.length) return parts.join(' / ');

    var fallbackTitle = variant && variant.title ? String(variant.title).trim() : '';
    if (fallbackTitle && fallbackTitle.toLowerCase() !== 'default title') {
      return fallbackTitle;
    }
    return 'Default';
  }

  function healixNormalizeColorGroupEntries(entries, isLimited) {
    if (!Array.isArray(entries)) return [];
    var seen = {};
    var output = [];

    entries.forEach(function(entry) {
      var variant = entry && entry.variant ? entry.variant : {};
      var handle = String(variant.handle || '').trim();
      if (!handle || seen[handle]) return;
      seen[handle] = true;

      var colorName = String(variant.color || handle || 'Color').replace(/_/g, ' ').trim();
      var colorCode = String(variant.color_code || '').trim() || '#cccccc';

      output.push({
        handle: handle,
        colorName: colorName || 'Color',
        colorCode: colorCode,
        isLimited: !!isLimited
      });
    });

    return output;
  }

  function healixLoadColorGroups(handle) {
    var normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) {
      return Promise.resolve({ core: [], limited: [], all: [] });
    }
    if (healixColorGroupsCache.has(normalizedHandle)) {
      return healixColorGroupsCache.get(normalizedHandle);
    }

    // Healix-specific: color groups for product-card dropdown come from swatch API.
    var requestPromise = window.HealixColors.colorProductSiblings([normalizedHandle])
      .then(function(payload) {
        var result = payload && payload.result ? payload.result : {};
        var core = healixNormalizeColorGroupEntries(result.core, false);
        var coreHandleSet = {};
        core.forEach(function(item) { coreHandleSet[item.handle] = true; });

        var limited = healixNormalizeColorGroupEntries(result.le, true).filter(function(item) {
          return !coreHandleSet[item.handle];
        });

        return {
          core: core,
          limited: limited,
          all: core.concat(limited)
        };
      })
      .catch(function(error) {
        console.warn('Healix-specific product-card color API failed', error);
        return { core: [], limited: [], all: [] };
      });

    healixColorGroupsCache.set(normalizedHandle, requestPromise);
    return requestPromise;
  }

  function healixLoadProductByHandle(handle) {
    var normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return Promise.resolve(null);
    var cacheKey = normalizedHandle;
    if (healixProductCache.has(cacheKey)) {
      return healixProductCache.get(cacheKey);
    }

    // Healix-specific: in-place color selection fetches selected handle product JSON.
    var requestPromise = fetch('/products/' + encodeURIComponent(normalizedHandle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Request failed: ' + response.status);
        return response.json();
      })
      .catch(function(error) {
        console.warn('Healix-specific product-card product fetch failed', error);
        return null;
      });

    healixProductCache.set(cacheKey, requestPromise);
    return requestPromise;
  }

  function healixResolveSelectSizeClass(selectWrapper) {
    if (!selectWrapper) return 'select--md';
    var className = selectWrapper.className || '';
    var sizeMatch = className.match(/select--(mini|sm|md|lg)/);
    return sizeMatch ? ('select--' + sizeMatch[1]) : 'select--md';
  }

  function healixSyncSelectComponent(selectWrapper) {
    if (!selectWrapper || !window.SelectComponent) return;

    if (!selectWrapper._selectComponent) {
      selectWrapper._selectComponent = new window.SelectComponent(selectWrapper);
      return;
    }

    var instance = selectWrapper._selectComponent;
    instance.nativeSelect = selectWrapper.querySelector('.select__native');
    instance.trigger = selectWrapper.querySelector('.select__trigger');
    instance.dropdown = selectWrapper.querySelector('.select__dropdown');
    instance.options = selectWrapper.querySelectorAll('.select__option');
    instance.body = selectWrapper.querySelector('.select__body');
    instance.searchInput = selectWrapper.querySelector('.select__search-input');
    instance.emptyState = selectWrapper.querySelector('.select__empty');

    instance.options.forEach(function(option) {
      if (option.dataset.healixBound === 'true') return;
      option.dataset.healixBound = 'true';
      option.addEventListener('click', function(event) {
        instance.handleOptionClick(event, option);
      });
    });

    instance.syncFromNative();
  }

  function healixRenderVariantOptions(selectWrapper, nativeSelect, variants, optionNames, colorOptionIndex, selectedVariantId) {
    if (!selectWrapper || !nativeSelect || !Array.isArray(variants) || !variants.length) return;

    var selectedValue = String(selectedVariantId || '');
    var nativeHtml = '<option value="">Please select</option>';
    var listHtml = '';

    variants.forEach(function(variant) {
      var variantValue = String(variant.id);
      var label = healixBuildVariantLabel(variant, optionNames, colorOptionIndex);
      if (!isVariantAvailable(variant)) {
        label += ' - Sold Out';
      }
      var isSelected = selectedValue === variantValue;
      nativeHtml += '<option value="' + healixEscapeHtml(variantValue) + '"' + (isSelected ? ' selected' : '') + '>' + healixEscapeHtml(label) + '</option>';
      listHtml += '<li class="select__option' + (isSelected ? ' select__option--selected' : '') + '" role="option" aria-selected="' + (isSelected ? 'true' : 'false') + '" data-value="' + healixEscapeHtml(variantValue) + '">' +
        '<span class="select__option-label">' + healixEscapeHtml(label) + '</span>' +
      '</li>';
    });

    nativeSelect.innerHTML = nativeHtml;
    if (selectedValue) {
      nativeSelect.value = selectedValue;
    }

    var optionsList = selectWrapper.querySelector('.select__options');
    if (optionsList) {
      optionsList.innerHTML = listHtml;
    }

    var body = selectWrapper.querySelector('.select__body');
    if (body) {
      body.innerHTML = '<span class="select__placeholder">Please select</span>';
    }

    healixSyncSelectComponent(selectWrapper);
  }

  function healixRenderSelectedColorSummary(colorSelectWrapper) {
    if (!colorSelectWrapper) return;
    var body = colorSelectWrapper.querySelector('.select__body');
    var nativeSelect = colorSelectWrapper.querySelector('.select__native');
    if (!body || !nativeSelect) return;

    var colorItems = Array.isArray(colorSelectWrapper._healixColorItems)
      ? colorSelectWrapper._healixColorItems
      : [];
    var selectedHandle = String(nativeSelect.value || '').trim();
    var selectedItem = colorItems.find(function(item) {
      return String(item.handle || '').trim() === selectedHandle;
    }) || colorItems[0];

    if (!selectedItem) return;

    var label = String(selectedItem.colorName || selectedItem.handle || 'Color').trim() || 'Color';
    var colorCode = String(selectedItem.colorCode || '#cccccc').trim() || '#cccccc';

    body.innerHTML =
      '<span class="product-card__healix-color-selected">' +
        '<span class="product-card__healix-color-dot" style="--healix-card-color:' + healixEscapeHtml(colorCode) + ';"></span>' +
        '<span class="select__value product-card__healix-color-selected-label">' + healixEscapeHtml(label) + '</span>' +
        (selectedItem.isLimited ? '<span class="product-card__healix-color-limited">Limited</span>' : '') +
      '</span>';

    var card = colorSelectWrapper.closest('.product-card');
    if (card) {
      healixSetCardColorTag(card, label, colorCode);
    }
  }

  function healixRenderColorDropdown(colorMount, colorItems, selectedHandle, selectSizeClass, productId) {
    if (!colorMount) return null;
    if (!Array.isArray(colorItems) || colorItems.length <= 1) {
      colorMount.hidden = true;
      colorMount.innerHTML = '';
      return null;
    }

    var selectedValue = String(selectedHandle || '');
    var selectedItem = colorItems.find(function(item) {
      return String(item.handle) === selectedValue;
    }) || colorItems[0];
    var selectName = 'healix-color-' + String(productId || 'card');

    var nativeOptionsHtml = '';
    var listOptionsHtml = '';
    colorItems.forEach(function(item) {
      var handle = String(item.handle || '').trim();
      if (!handle) return;
      var isSelected = handle === selectedValue;
      var label = String(item.colorName || handle).trim() || handle;
      var nativeLabel = item.isLimited ? (label + ' (Limited)') : label;

      nativeOptionsHtml += '<option value="' + healixEscapeHtml(handle) + '"' + (isSelected ? ' selected' : '') + '>' + healixEscapeHtml(nativeLabel) + '</option>';
      listOptionsHtml += '<li class="select__option' + (isSelected ? ' select__option--selected' : '') + '" role="option" aria-selected="' + (isSelected ? 'true' : 'false') + '" data-value="' + healixEscapeHtml(handle) + '">' +
        '<span class="product-card__healix-color-dot" style="--healix-card-color:' + healixEscapeHtml(item.colorCode || '#cccccc') + ';"></span>' +
        '<span class="select__option-label">' + healixEscapeHtml(label) + '</span>' +
        (item.isLimited ? '<span class="product-card__healix-color-limited">Limited</span>' : '') +
      '</li>';
    });

    colorMount.innerHTML =
      '<div class="select ' + selectSizeClass + ' select--filled product-card__healix-color-select" data-select data-healix-color-select data-select-name="' + healixEscapeHtml(selectName) + '" data-select-multiple="false">' +
        '<select name="' + healixEscapeHtml(selectName) + '" class="select__native" aria-hidden="true" tabindex="-1">' +
          nativeOptionsHtml +
        '</select>' +
        '<button type="button" class="select__trigger" aria-haspopup="listbox" aria-expanded="false">' +
          '<span class="select__body"></span>' +
          '<span class="select__arrow"><svg class="select__arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>' +
        '</button>' +
        '<div class="select__dropdown" role="listbox">' +
          '<ul class="select__options">' + listOptionsHtml + '</ul>' +
          '<div class="select__empty" style="display:none;"><span>No options found</span></div>' +
        '</div>' +
      '</div>';

    colorMount.hidden = false;
    var colorSelectWrapper = colorMount.querySelector('[data-healix-color-select]');
    colorSelectWrapper._healixColorItems = colorItems.slice();
    healixSyncSelectComponent(colorSelectWrapper);
    healixRenderSelectedColorSummary(colorSelectWrapper);
    return colorSelectWrapper;
  }

  function healixSyncColorDropdownSelection(colorSelectWrapper, nextHandle) {
    if (!colorSelectWrapper) return;
    var nativeSelect = colorSelectWrapper.querySelector('.select__native');
    if (!nativeSelect) return;
    nativeSelect.value = String(nextHandle || '');
    healixSyncSelectComponent(colorSelectWrapper);
    healixRenderSelectedColorSummary(colorSelectWrapper);
  }

  function healixGetProductFeaturedImage(productData) {
    if (!productData) return '';
    if (productData.featured_image) {
      return typeof productData.featured_image === 'string'
        ? productData.featured_image
        : (productData.featured_image.src || '');
    }
    if (Array.isArray(productData.images) && productData.images.length) {
      return typeof productData.images[0] === 'string'
        ? productData.images[0]
        : (productData.images[0].src || '');
    }
    return '';
  }

  function healixUpdateCardHandle(card, nextHandle, nextTitle) {
    if (!card || !nextHandle) return;
    var productUrl = '/products/' + nextHandle;
    card.setAttribute('data-product-handle', nextHandle);
    card.setAttribute('data-product-url', productUrl);

    var imageLink = card.querySelector('.product-card__image-container');
    if (imageLink) {
      imageLink.setAttribute('href', productUrl);
    }

    var addButtonLink = card.querySelector('.product-card__add-btn[href]');
    if (addButtonLink) {
      addButtonLink.setAttribute('href', productUrl);
    }

    if (nextTitle) {
      card.querySelectorAll('.product-card__title-text').forEach(function(titleNode) {
        var innerHeading = titleNode.querySelector('span');
        if (innerHeading) {
          innerHeading.textContent = nextTitle;
        } else {
          titleNode.textContent = nextTitle;
        }
      });
    }

    var wishlistButton = card.querySelector('[data-wishlist-btn]');
    if (wishlistButton) {
      wishlistButton.setAttribute('data-product-handle', nextHandle);
      wishlistButton.setAttribute('data-product-url', productUrl);
      if (nextTitle) {
        wishlistButton.setAttribute('data-product-title', nextTitle);
      }
    }

    healixHydrateCardColorTag(card, nextHandle);
  }

  function initHealixCardColorTags() {
    document.querySelectorAll('.product-card[data-product-card]').forEach(function(card) {
      var handle = String(card.getAttribute('data-product-handle') || '').trim();
      if (!handle) return;
      healixHydrateCardColorTag(card, handle);
    });
  }

  function initVariantSelectors() {
    document.querySelectorAll('.product-card[data-product-card] .product-card__variants').forEach(function(container) {
      if (container.hasAttribute('data-variants-initialized')) return;
      container.setAttribute('data-variants-initialized', 'true');

      var card = container.closest('.product-card');
      if (!card) return;

      var selectWrapper = container.querySelector('[data-select]');
      var nativeSelect = container.querySelector('.select__native');
      var variantsJson = card.querySelector('.product-card__variants-json');
      if (!nativeSelect || !variantsJson) return;

      var productMetaJson = card.querySelector('.product-card__product-meta-json');
      var productMeta = {};
      var variantsState = [];
      var optionNamesState = [];
      var colorOptionIndexState = -1;
      var fallbackImageSrc = '';
      var currentHandleState = String(card.getAttribute('data-product-handle') || '').trim();
      var colorMount = card.querySelector('[data-healix-color-mount]');
      var colorSelectWrapper = null;

      if (productMetaJson) {
        try {
          productMeta = JSON.parse(productMetaJson.textContent || '{}');
        } catch (metaError) {
          productMeta = {};
        }
      }

      try {
        variantsState = JSON.parse(variantsJson.textContent || '[]');
      } catch (e) {
        variantsState = [];
      }

      if (!variantsState.length) return;

      if (!currentHandleState && productMeta && productMeta.handle) {
        currentHandleState = String(productMeta.handle).trim();
      }

      optionNamesState = healixNormalizeOptionNames(productMeta.options || []);
      colorOptionIndexState = healixFindColorOptionIndex(optionNamesState);
      fallbackImageSrc = (card.querySelector('.product-card__image') || {}).src || '';

      function updateAddButtonState(selectedVariant) {
        var addBtn = card.querySelector('[data-add-to-cart]');
        if (!addBtn) return;

        if (!selectedVariant || !selectedVariant.id) {
          addBtn.disabled = true;
          addBtn.classList.add('btn--disabled');
          addBtn.removeAttribute('data-variant-id');
          var missingVariantText = addBtn.querySelector('.btn__text');
          if (missingVariantText) missingVariantText.textContent = 'Sold Out';
          var missingVariantIcon = addBtn.querySelector('.btn__icon');
          if (missingVariantIcon) missingVariantIcon.style.display = 'none';
          return;
        }

        addBtn.dataset.variantId = selectedVariant.id;

        var productAvailable = card.getAttribute('data-product-available') !== 'false';
        if (productAvailable && isVariantAvailable(selectedVariant)) {
          addBtn.disabled = false;
          addBtn.classList.remove('btn--disabled');
          var addText = addBtn.querySelector('.btn__text');
          if (addText) addText.textContent = 'Add to Cart';
          var addIcon = addBtn.querySelector('.btn__icon');
          if (addIcon) addIcon.style.display = '';
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('btn--disabled');
          var soldOutText = addBtn.querySelector('.btn__text');
          if (soldOutText) soldOutText.textContent = 'Sold Out';
          var soldOutIcon = addBtn.querySelector('.btn__icon');
          if (soldOutIcon) soldOutIcon.style.display = 'none';
        }
      }

      function handleVariantChange(variantId) {
        if (!variantId) {
          updateAddButtonState(null);
          return;
        }

        var selectedVariant = variantsState.find(function(variant) {
          return String(variant.id) === String(variantId);
        });
        if (!selectedVariant) {
          updateAddButtonState(null);
          return;
        }

        updatePriceDisplay(card, selectedVariant.price, selectedVariant.compare_at_price);
        updateProductImage(card, selectedVariant, fallbackImageSrc);
        updateProductLinks(card, selectedVariant.id);
        updateAddButtonState(selectedVariant);
      }

      function handleHealixColorChange(nextHandle) {
        var normalizedNextHandle = String(nextHandle || '').trim();
        if (!normalizedNextHandle || normalizedNextHandle === currentHandleState) return;

        var selectedVariant = variantsState.find(function(variant) {
          return String(variant.id) === String(nativeSelect.value || '');
        }) || findFirstAvailableVariant(variantsState);
        var preferredSelections = healixBuildPreferredSelections(
          selectedVariant,
          optionNamesState,
          colorOptionIndexState
        );

        healixLoadProductByHandle(normalizedNextHandle).then(function(nextProduct) {
          if (!nextProduct || !Array.isArray(nextProduct.variants) || !nextProduct.variants.length) {
            healixSyncColorDropdownSelection(colorSelectWrapper, currentHandleState);
            return;
          }

          var nextVariants = nextProduct.variants;
          var nextOptionNames = healixNormalizeOptionNames(nextProduct.options || []);
          var nextColorOptionIndex = healixFindColorOptionIndex(nextOptionNames);
          var matchedVariant = healixFindVariantBySelections(
            nextVariants,
            nextOptionNames,
            nextColorOptionIndex,
            preferredSelections
          ) || findFirstAvailableVariant(nextVariants) || null;

          variantsState = nextVariants;
          optionNamesState = nextOptionNames;
          colorOptionIndexState = nextColorOptionIndex;
          currentHandleState = String(nextProduct.handle || normalizedNextHandle).trim() || normalizedNextHandle;
          fallbackImageSrc = healixGetProductFeaturedImage(nextProduct) || fallbackImageSrc;

          var nextProductAvailable = nextProduct.available === true;
          card.setAttribute('data-product-available', String(nextProductAvailable));

          healixUpdateCardHandle(card, currentHandleState, nextProduct.title || '');
          healixUpdateCardMediaCarousel(card, nextProduct, matchedVariant);
          healixRenderVariantOptions(
            selectWrapper,
            nativeSelect,
            variantsState,
            optionNamesState,
            colorOptionIndexState,
            matchedVariant && matchedVariant.id
          );

          if (matchedVariant && matchedVariant.id) {
            handleVariantChange(matchedVariant.id);
          } else {
            updateAddButtonState(null);
          }
          healixSyncColorDropdownSelection(colorSelectWrapper, currentHandleState);
        });
      }

      if (selectWrapper) {
        selectWrapper.addEventListener('select:change', function(e) {
          handleVariantChange(e.detail && e.detail.value);
        });
      }

      nativeSelect.addEventListener('change', function() {
        handleVariantChange(nativeSelect.value);
      });

      // Healix-specific: render API-backed color dropdown whenever variant selector is enabled.
      // Do not require a native "Color" option; Healix colors can be cross-product siblings.
      if (colorMount && currentHandleState) {
        var initialVariantId = nativeSelect.value || (variantsState[0] && variantsState[0].id);
        healixRenderVariantOptions(
          selectWrapper,
          nativeSelect,
          variantsState,
          optionNamesState,
          colorOptionIndexState,
          initialVariantId
        );
        handleVariantChange(initialVariantId);

        healixLoadColorGroups(currentHandleState).then(function(groups) {
          var colorItems = groups && Array.isArray(groups.all) ? groups.all : [];
          colorSelectWrapper = healixRenderColorDropdown(
            colorMount,
            colorItems,
            currentHandleState,
            healixResolveSelectSizeClass(selectWrapper),
            card.getAttribute('data-product-id')
          );
          if (!colorSelectWrapper) return;

          var colorNativeSelect = colorSelectWrapper.querySelector('.select__native');
          colorSelectWrapper.addEventListener('select:change', function(event) {
            healixRenderSelectedColorSummary(colorSelectWrapper);
            handleHealixColorChange(event && event.detail ? event.detail.value : '');
          });

          if (colorNativeSelect) {
            colorNativeSelect.addEventListener('change', function() {
              healixRenderSelectedColorSummary(colorSelectWrapper);
              handleHealixColorChange(colorNativeSelect.value);
            });
          }
        });
      } else if (colorMount) {
        colorMount.hidden = true;
      }
    });
  }

  function initHealixColorDropdowns() {
    document.querySelectorAll('.product-card[data-product-card] [data-healix-color-mount]').forEach(function(colorMount) {
      if (colorMount.hasAttribute('data-healix-dropdown-initialized')) return;

      var card = colorMount.closest('.product-card');
      if (!card) return;
      if (card.querySelector('.product-card__variants[data-variants-initialized]') || card.querySelector('.product-card__variants')) return;

      colorMount.setAttribute('data-healix-dropdown-initialized', 'true');

      var currentHandleState = String(card.getAttribute('data-product-handle') || '').trim();
      if (!currentHandleState) { colorMount.hidden = true; return; }

      var variantsJson = card.querySelector('.product-card__variants-json');
      var productMetaJson = card.querySelector('.product-card__product-meta-json');
      var variantsState = [];
      var productMeta = {};

      if (variantsJson) {
        try { variantsState = JSON.parse(variantsJson.textContent || '[]'); } catch (e) { variantsState = []; }
      }
      if (productMetaJson) {
        try { productMeta = JSON.parse(productMetaJson.textContent || '{}'); } catch (e) { productMeta = {}; }
      }
      if (!currentHandleState && productMeta.handle) {
        currentHandleState = String(productMeta.handle).trim();
      }

      var optionNamesState = healixNormalizeOptionNames(productMeta.options || []);
      var colorOptionIndexState = healixFindColorOptionIndex(optionNamesState);
      var fallbackImageSrc = (card.querySelector('.product-card__image') || {}).src || '';
      var colorSelectWrapper = null;

      function handleHealixColorChange(nextHandle) {
        var normalizedNextHandle = String(nextHandle || '').trim();
        if (!normalizedNextHandle || normalizedNextHandle === currentHandleState) return;

        healixLoadProductByHandle(normalizedNextHandle).then(function(nextProduct) {
          if (!nextProduct) {
            healixSyncColorDropdownSelection(colorSelectWrapper, currentHandleState);
            return;
          }

          currentHandleState = String(nextProduct.handle || normalizedNextHandle).trim();
          fallbackImageSrc = healixGetProductFeaturedImage(nextProduct) || fallbackImageSrc;

          var nextVariants = nextProduct.variants || [];
          var bestVariant = findFirstAvailableVariant(nextVariants) || null;
          var nextProductAvailable = nextProduct.available === true;
          card.setAttribute('data-product-available', String(nextProductAvailable));

          healixUpdateCardHandle(card, currentHandleState, nextProduct.title || '');
          healixUpdateCardMediaCarousel(card, nextProduct, bestVariant);
          updateProductImage(card, bestVariant, fallbackImageSrc);

          if (bestVariant && bestVariant.id) {
            updatePriceDisplay(card, bestVariant.price, bestVariant.compare_at_price);
            updateProductLinks(card, bestVariant.id);
          }

          var addBtn = card.querySelector('[data-add-to-cart]');
          if (addBtn) {
            if (bestVariant && bestVariant.id && nextProductAvailable && isVariantAvailable(bestVariant)) {
              addBtn.dataset.variantId = bestVariant.id;
              addBtn.disabled = false;
              addBtn.classList.remove('btn--disabled');
              var txt = addBtn.querySelector('.btn__text');
              if (txt) txt.textContent = 'Add to Cart';
              var addIcon = addBtn.querySelector('.btn__icon');
              if (addIcon) addIcon.style.display = '';
            } else {
              addBtn.disabled = true;
              addBtn.classList.add('btn--disabled');
              addBtn.removeAttribute('data-variant-id');
              var txt2 = addBtn.querySelector('.btn__text');
              if (txt2) txt2.textContent = 'Sold Out';
              var soldOutIcon = addBtn.querySelector('.btn__icon');
              if (soldOutIcon) soldOutIcon.style.display = 'none';
            }
          }

          healixSyncColorDropdownSelection(colorSelectWrapper, currentHandleState);
        });
      }

      healixLoadColorGroups(currentHandleState).then(function(groups) {
        var colorItems = groups && Array.isArray(groups.all) ? groups.all : [];
        colorSelectWrapper = healixRenderColorDropdown(
          colorMount,
          colorItems,
          currentHandleState,
          'select--md',
          card.getAttribute('data-product-id')
        );
        if (!colorSelectWrapper) return;

        var colorNativeSelect = colorSelectWrapper.querySelector('.select__native');
        colorSelectWrapper.addEventListener('select:change', function(event) {
          healixRenderSelectedColorSummary(colorSelectWrapper);
          handleHealixColorChange(event && event.detail ? event.detail.value : '');
        });

        if (colorNativeSelect) {
          colorNativeSelect.addEventListener('change', function() {
            healixRenderSelectedColorSummary(colorSelectWrapper);
            handleHealixColorChange(colorNativeSelect.value);
          });
        }
      });
    });
  }

  function initColorSwatchNavigation() {
    if (initColorSwatchNavigation._done) return;
    initColorSwatchNavigation._done = true;
    document.addEventListener(
      'click',
      function (e) {
        var sw = e.target.closest('.color-swatch[data-navigate]');
        if (!sw) return;
        e.preventDefault();
        e.stopPropagation();
        var url = sw.getAttribute('data-navigate');
        if (url) window.location.assign(url);
      },
      true
    );
    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var sw = e.target.closest('.color-swatch[data-navigate]');
        if (!sw || sw !== e.target) return;
        e.preventDefault();
        e.stopPropagation();
        var url = sw.getAttribute('data-navigate');
        if (url) window.location.assign(url);
      },
      true
    );
  }

  function hydrateSwatchContainer(parentEl, handle, swatchContainer) {
    var maxSwatches = parseInt(swatchContainer.getAttribute('data-max-swatches') || '0', 10) || 0;

    healixLoadColorGroups(handle).then(function(groups) {
      var items = groups && Array.isArray(groups.all) ? groups.all : [];
      if (items.length <= 1) {
        swatchContainer.style.display = 'none';
        return;
      }

      var activeItem = null;
      var dotsHTML = '';
      var rendered = 0;
      for (var i = 0; i < items.length; i++) {
        if (maxSwatches > 0 && rendered >= maxSwatches) break;
        var item = items[i];
        var isActive = String(item.handle) === handle;
        if (isActive) activeItem = item;
        var hex = healixEscapeHtml(item.colorCode || '#cccccc');
        var label = healixEscapeHtml(item.colorName || 'Color');
        dotsHTML +=
          '<span role="link" tabindex="0" data-navigate="/products/' + healixEscapeHtml(item.handle) + '"' +
          ' class="color-swatch' + (isActive ? ' color-swatch--active' : '') + '"' +
          ' title="' + label + '"' +
          ' style="--cs-color: ' + hex + '; background-color: ' + hex + ';"' +
          ' aria-label="' + label + '"></span>';
        rendered++;
      }

      var remainingCount = items.length - rendered;
      if (maxSwatches > 0 && remainingCount > 0) {
        dotsHTML += '<span class="color-swatches__more">+' + remainingCount + '</span>';
      }

      swatchContainer.innerHTML = dotsHTML;
      swatchContainer.style.display = '';

      var labelEl = parentEl.querySelector('[data-color-label-value]');
      if (labelEl && activeItem) {
        labelEl.textContent = activeItem.colorName || '';
      }
    });
  }

  function initHealixColorSwatches() {
    var targets = document.querySelectorAll('.product-card[data-product-card], .product-color-swatches-block[data-product-handle]');
    targets.forEach(function(el) {
      var swatchContainer = el.querySelector('.color-swatches[data-healix-swatches]');
      if (!swatchContainer) return;
      if (swatchContainer.hasAttribute('data-healix-swatches-loaded')) return;
      swatchContainer.setAttribute('data-healix-swatches-loaded', 'true');

      var handle = String(el.getAttribute('data-product-handle') || '').trim();
      if (!handle) { swatchContainer.style.display = 'none'; return; }

      hydrateSwatchContainer(el, handle, swatchContainer);
    });
  }

  function initProductCards() {
    initColorSwatchNavigation();
    checkTitleOverflow();
    checkPriceOverflow();
    initCarousels();
    initBadgeRotation();
    initSelectComponentsSafe();
    initVariantSelectors();
    initHealixColorDropdowns();
    initHealixColorSwatches();
    initHealixCardColorTags();
    initAddToCartButtons();
  }
  
  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductCards();
    });
  } else {
    initProductCards();
  }

  document.addEventListener('product-card:updated', function() {
    initProductCards();
  });

  document.addEventListener('shopify:section:load', function() {
    initProductCards();
  });

  function initAddToCartButtons() {
    document.querySelectorAll('[data-product-card] [data-add-to-cart]').forEach(function(button) {
      if (button.hasAttribute('data-card-initialized')) return;
      button.setAttribute('data-card-initialized', 'true');

      button.addEventListener('click', handleAddToCart);
    });
  }

  async function handleAddToCart(e) {
    e.preventDefault();
    var button = e.currentTarget;
    var variantId = button.dataset.variantId;

    if (!variantId || button.classList.contains('btn--loading') || button.disabled) return;

    button.classList.add('btn--loading');
    button.disabled = true;

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      var addedItem = await response.json();
      window.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: {
          item: addedItem
        }
      }));
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      button.classList.remove('btn--loading');
      button.disabled = false;
    }
  }
  
  // Run on resize
  window.addEventListener('resize', function() {
    checkTitleOverflow();
    checkPriceOverflow();
  });
})();
